// extracted by mini-css-extract-plugin
export default {"layer":"layer-ylRPj","lockedScrollByLayer":"lockedScrollByLayer-v4KGB"};